import { Action, createReducer, on } from "@ngrx/store";
import { EntitySexoState, entitytSexoAdapter, initialState } from "./entity-sexo.state";
import { entitySexosLoadRequest, entitySexosLoadSuccess } from "./entity-sexo.actions";

const reducer = createReducer(
  initialState,
  on(entitySexosLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entitySexosLoadSuccess, (state, { items }) =>
    entitytSexoAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
)

export function entitySexoReducer(
  state: EntitySexoState | undefined,
  action: Action
) {
  return reducer(state, action);
}
